import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { CustomerInfo } from '../model/customer-info';
import { environment } from 'src/environments/environment';

export interface CustomerInfoResponse {
  data: CustomerInfo;
  error: Array<string>;
}

@Injectable({
  providedIn: 'root'
})
export class CustomerInfoService {
  private readonly http = inject(HttpClient);

  constructor() {}

  getCustomerInfo(dealerId?: string, customerCode?: string): Observable<CustomerInfoResponse> {
    // TODO: dealerId should be in the JWT. Should check here
    const url = `${environment.apiUrl}${environment.serviceUris.assets}dealers/${dealerId}/customers/${customerCode}`;

    return this.http.get<CustomerInfoResponse>(url);
  }
}
